<template>
    <div class="outer-wrapper d-flex flex-column align-items-stretch gap-3" :style="[{'min-width': listWidth}]">
        <h6 class="before-extra-large-text text-start extra-black-color" v-if="showTitle">{{ title }}</h6>
        <div v-if="showOptionalHeader">
            <slot name="optionalHeader">
    
            </slot>
        </div>
        <ul class="list-overflow-wrapper common-scrollbar d-flex flex-column align-items-start gap-2" :style="[{'height': listHeight}]">
            <slot name="list">
        
            </slot>
        </ul>
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    props: {
        title: String,
        listWidth: {
            type: String,
            default: "190px",
        },
        listHeight: {
            type: String,
            default: "240px",
        },
        showOptionalHeader: {
            type: Boolean,
            default: false,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
    }
}
</script>
<style scoped>
.list-overflow-wrapper{
    overflow-y: scroll;
    padding-right: 1.5em;
    scroll-snap-type: block mandatory;
}
.list-overflow-wrapper > *{
    scroll-snap-align: start;
}
</style>